import React from "react";
import {QRCodeCanvas} from 'qrcode.react';
import styled from "styled-components";
import {ReactComponent as Icon1} from "../assets/icons/001.svg";
import {ReactComponent as Icon2} from "../assets/icons/002.svg";
import {ReactComponent as Icon3} from "../assets/icons/003.svg";

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const HeaderWrapper = styled.div`
    height: 500px;
    background-color: rgba(17, 0, 255, 0.15);

    display: flex;
    align-items: center;
    justify-content: center;
`

const BodyWrapper = styled.div`
    padding: 20px 20px 120px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const TitleWrapper = styled.div`
    padding: 20px;
    margin-right: 100px;

    display: flex;

    div {
        padding: 10px;

        &.title {
            margin-right: 20px;

            h1 {
                font-size: 56px;
                font-weight: 700;
                line-height: 66px;
                color: rgba(29, 33, 41, 1);
                text-align: left;
                vertical-align: top;
            }

            p {
                font-size: 18px;
                font-weight: 400;
                line-height: 28px;
                color: rgba(29, 33, 41, 1);
                text-align: left;
                vertical-align: top;
            }
        }
    }
`

const FunctionWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
`

const Function = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 311px;

    div.title {
        height: 96px;
        opacity: 1;
        background: rgba(255, 255, 255, 1);

        border: 1px solid rgba(29, 33, 41, 1);

        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 20px;

        h1 {
            font-size: 18px;
            font-weight: 500;
            line-height: 28px;
            color: rgba(29, 33, 41, 1);
            text-align: left;
            vertical-align: top;
        }

        i {
            margin-right: 20px;
        }
    }

    p {
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        color: rgba(29, 33, 41, 1);
        text-align: left;
        vertical-align: top;
    }
`

const DownloadWrapper = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div.description {
        margin-top: 10px;
        font-weight: 500;
    }
`

const qrValue = "https://portal.zhitouhui.top/downloads/android/1739022852182.apk";
const pic = require("../assets/images/002.jpg")

const function_list = [
    {title: "热点资讯", description: "实时追踪市场热点新闻与行业动态，快速识别潜在投资机会与风险。", icon: Icon1},
    {
        title: "盘前策略",
        description: "基于热点信息、市场情绪和交易数据，制定开盘前的交易计划，把握早盘波动机会。",
        icon: Icon2
    },
    {title: "竞价策略", description: "利用集合竞价阶段的量价变化，精准捕捉开盘价附近的交易信号。", icon: Icon3},
]

const downloadVisible = false

const Home = () => {
    return (
        <Container>
            <HeaderWrapper>
                <TitleWrapper>
                    <div class="title">
                        <h1>智投汇</h1>
                        <p>AI帮助您实现更高效、更智能的交易决策</p>
                    </div>
                    <div>
                        <img src={pic} width={200} height={240} alt=""/>
                    </div>
                </TitleWrapper>
                {downloadVisible && (
                    <DownloadWrapper>
                        <QRCodeCanvas
                            value={qrValue}
                            size={200}
                            bgColor="#ffffff"
                            fgColor="#000000"
                            level="H"
                            marginSize={2}
                        />
                        <div class="description">Android APP 扫码下载</div>
                    </DownloadWrapper>
                )}
            </HeaderWrapper>
            <BodyWrapper>
                <h1>产品功能</h1>

                <FunctionWrapper>
                    {function_list.map(item => (
                        <Function>

                            <div class="title">
                                <i>
                                    <item.icon/>
                                </i>
                                <h1>
                                    {item.title}
                                </h1>
                            </div>

                            <p>
                                {item.description}
                            </p>
                        </Function>
                    ))}
                </FunctionWrapper>

            </BodyWrapper>
        </Container>
    );
}

export default Home;